import ElementColors from './ElementColors';

export default {
  elementColors: [ 'type', ElementColors ]
};